// extracted by mini-css-extract-plugin
export default {"popUpWrap":"styles_popUpWrap__0FtG8","popUp":"styles_popUp__-yWIS","popUpOpen":"styles_popUpOpen__TuyHK"};